import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { InfoCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import { PURPLE } from "../../styles/styleUtils"
import ToggleButton from '../common/ToggleButton'
import CustomTable from "../common/CustomTable"
import UMCButton from "../common/UMCButton"
import { useWindowSize } from '../../components/customHooks/useWindowSize'
import { getTranslated, formatDictString } from "../../utils/CommonUtils"
import { getTableSchema, getSchemaDataResponse } from "../../store/actions/CommonActions"
import { deleteDirectoryUsers, deleteUser, getDirectorySynchroUserList, getDirectrySynchroCompareData } from "../../store/actions/UUMActions"
import { setDirectorySynchroTableSchema, setDirectorySynchroTableList, setIsUpdateAutoTab, setDirectorySynchroFilteredList, setCreateUserFromDirectorySynchro, setUserSCIMId, setDirectorySynchroCompareTableSchema, setDirectorySynchroMode, setDirectorySychroUserDN, setIsCompareSyncwithOXE } from "../../store/reducers/UUMReducer"
import { setContentLoading, setCurrentMergedData, setExtraContent } from '../../store/reducers/CommonReducer'
import { DIRECTORY_SYNCHRO_URL } from "../../utils/Config"
import { getSessionItem } from "../../utils/storageUtils"
import { TOKEN_2, UPDATE, DIRECTORY_SYNCHRO } from "../../utils/Constants"
import UserProfileSummaryView from "./UserProfileSummaryView";
import CreateUserDetailView from "./CreateUserDetailView"
import confirmModal from "../common/confirmModal"
import { sendGTMEvent } from "../../utils/GTMUtils"


const DirectorySynchroList = () => {

  const [width, height] = useWindowSize()

  const dispatch = useDispatch()
  const [selectedRows, setSelectedRows] = useState([])
  const [newcreate, setnewcreate] = useState(false)
  const [autoUpdate, setAutoupdate] = useState()

  const dict = useSelector((state) => state.common.dict)
  const language = useSelector(state => state.common.language)
  const directorySynchroTableSchema = useSelector((state) => state.uum.directorySynchroTableSchema)
  const directorySynchroTableList = useSelector((state) => state.uum.directorySynchroTableList)
  const directorySynchroFilteredList = useSelector((state) => state.uum.directorySynchroFilteredList)
  const isUpdateAuto = useSelector((state) => state.uum.isUpdateAuto)
  const createUserFromDirectorySynchro = useSelector((state) => state.uum.createUserFromDirectorySynchro)
  const directorySynchroMode = useSelector((state) => state.uum.directorySynchroMode)
  const directorySychroUserDN = useSelector((state) => state.uum.directorySychroUserDN)
  const userSCIMId = useSelector((state) => state.uum.userSCIMId)
  const directorySynchroCompareTableSchema = useSelector((state) => state.uum.directorySynchroCompareTableSchema)

  useEffect(() => {
    let extraContent = ["refresh", "help"];
    dispatch(setContentLoading(true))
    dispatch(getTableSchema({ url: `${DIRECTORY_SYNCHRO_URL}/schema/directorySynchro/list`, action: setDirectorySynchroTableSchema }))
    dispatch(getDirectorySynchroUserList(setDirectorySynchroTableList))
    dispatch(setContentLoading(false))
    dispatch(setCurrentMergedData(null))
    dispatch(setExtraContent(extraContent))
    dispatch(setCreateUserFromDirectorySynchro(false))
  }, [])

  useEffect(() => {
    if (isUpdateAuto !== undefined) {
      dispatch(setContentLoading(true))
      fetch(`${DIRECTORY_SYNCHRO_URL}/directorySynchro/setAutoUpdate?isAutoUpdate=${isUpdateAuto}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`
        }
      })
        .then(async (response) => {
          const contentType = response.headers.get("content-type")
          return contentType && contentType.includes("application/json")
            ? response.json()
            : response.text()
        })
        .then((data) => {
          dispatch(setContentLoading(false))
          console.log("AutoUpdate API Response:", data)
        })
        .catch((err) => {
          console.error("Error calling AutoUpdate API:", err)
        })
    }
  }, [isUpdateAuto])

  useEffect(() => {
    if (directorySynchroMode === "CHECK") {
      dispatch(getSchemaDataResponse({ url: `${DIRECTORY_SYNCHRO_URL}/schema/directorySynchro/compare`, action: setDirectorySynchroCompareTableSchema }))
    }
  }, [directorySynchroMode])

  useEffect(() => {
    dispatch(getDirectorySynchroUserList(setDirectorySynchroTableList))
  }, [language])

  const dirSyncOxeActionHandling = (item, rowData) => {
    const url = `${DIRECTORY_SYNCHRO_URL}/directorySynchro/deleteUsers`
    if (item?.attribute?.oxeactions[0]?.id === "delete") {

      const name = item?.attribute?.name;
      confirmModal({
        title: getTranslated(dict, "DELETE_CONFIRMATION"),
        icon: "icon_warning.svg",
        okText: getTranslated(dict, "LABEL_YES"),
        cancelText: getTranslated(dict, "LABEL_NO"),
        onOk: () => {
          dispatch(setContentLoading(true))
          dispatch(deleteUser([rowData?.dn], (status, resp) => {
            if (status) {
              dispatch(deleteDirectoryUsers(url, [rowData?.id]))
              dispatch(setContentLoading(false))
            } else {
              dispatch(setContentLoading(false))
              confirmModal({
                title: "MSG_USER_DEL_FAIL",
                content: resp?.errorMessage,
                type: "error",
                okText: "LABEL_OK"
              })
            }
          }))
          },
          onCancel: () => {
            dispatch(setContentLoading(false))
          },
          content: getTranslated(dict, `${name}`),
          closable: true,
          centered: true,
        })
        triggerGTMActionEvents("DELETE")
      } else if (item?.attribute?.oxeactions[0]?.id === "create") {
        dispatch(setCreateUserFromDirectorySynchro(true))
        dispatch(setUserSCIMId(item.id))
        dispatch(setDirectorySynchroMode("CREATE"))
        triggerGTMActionEvents("CREATE")
      } else if (item?.attribute?.oxeactions[0]?.id === "modify") {
        dispatch(setCreateUserFromDirectorySynchro(true))
        dispatch(setUserSCIMId(item.id))
        dispatch(setDirectorySychroUserDN(item?.attribute?.dn))
        dispatch(setDirectorySynchroMode("MODIFY"))
        triggerGTMActionEvents("MODIFY")
      } else if (item?.attribute?.oxeactions[0]?.id === "compare") {
        dispatch(setCreateUserFromDirectorySynchro(true))
        dispatch(setUserSCIMId(item.id))
        dispatch(setDirectorySychroUserDN(item?.attribute?.dn))
        dispatch(setDirectorySynchroMode("CHECK"))
        dispatch(setIsCompareSyncwithOXE(false))
        triggerGTMActionEvents("CHECK")
      }
  }

  const triggerGTMActionEvents = (action) => {
    sendGTMEvent({
      event: "umc_directory_synchro",
      action: "Action selection: " + action
    })
  }


  const getTable = () => {
    return (
      <div style={{ padding: "20px" }}>
        <CustomTable
          schema={directorySynchroTableSchema}
          filteredData={directorySynchroFilteredList}
          tableData={directorySynchroTableList}
          updateTableAction={setDirectorySynchroFilteredList}
          height={height <= 585 ? "19em" : "50vh"}
          closable={true}
          fetchData={getDirectorySynchroUserList}
          bulk={true}
          selectedRows={selectedRows}
          // handleRowSelect={handleRowSelect}
          handleBulkSelection={(rows) => {
            console.log("buk", rows)
            setSelectedRows(rows)
          }}
          dirSyncOxeActionHandling={dirSyncOxeActionHandling}
          tabKey={DIRECTORY_SYNCHRO}
        />
      </div>
    )
  }

  const getRemoveLabel = () => {
    return (
      !selectedRows?.length
        ? getTranslated(dict, "LABEL_REMOVE_FROM_SYNCHRONIZATION_LIST")
        : getTranslated(dict, "LABEL_REMOVE_FROM_SYNCHRONIZATION_LIST") + ` (${selectedRows.length} ${getTranslated(dict, "LABEL_SELECTED")})`
    )
  }

  const getCreateLable = () => {
    const selectedRowCreateID = getSelectedRowCreateID()
    return (
      !selectedRowCreateID?.length
        ? getTranslated(dict, "LABEL_CREATE")
        : getTranslated(dict, "LABEL_CREATE") + ` (${selectedRowCreateID.length}  ${getTranslated(dict, "LABEL_SELECTED")})`
    )
  }

  const getSelectedRowCreateID = () => {
    const directoryList = directorySynchroFilteredList || [];
    const selectedRowCreate = directoryList.filter(item2 => selectedRows.find(item1 => item1 === item2.id));
    const selectedRowCreateID = selectedRowCreate
      .filter(item => item.attribute?.type?.[0]?.id === "new")
      .map(item => item.id)
    return selectedRowCreateID
  }

  const getTableHeader = () => {
    return (
      <div
        className="inner-tab-hd-container"
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between"
        }}
      >
        <UMCButton
          danger
          label={getRemoveLabel()}
          className="cont-header-btn"
          type={(selectedRows?.length > 0) ? "primary" : ""}
          disabled={(selectedRows != []) ? false : true}
          onClick={() => {
            if (selectedRows?.length > 0){
            const url = `${DIRECTORY_SYNCHRO_URL}/directorySynchro/deleteUsers`
            dispatch(setContentLoading(true))
            dispatch(deleteDirectoryUsers(url, selectedRows, setDirectorySynchroTableList))
            }
            sendGTMEvent({ 
              event: "umc_directory_synchro",
              action: "DS_REMOVE_From_Synchro_List"
            })
          }
          }
        />

        <div
          style={{ display: "flex", alignItems: "center" }}
        >
          <ToggleButton
            options={[{
              label: getTranslated(dict, "LABEL_UPDATE_AUTO"),
              value: true
            }, {
              label: getTranslated(dict, "LABEL_UPDATE_MANUAL"),
              value: false,
            }]}
            className="cont-header-btn last-option"
            value={isUpdateAuto}
            handleChange={(value) => {
              dispatch(setIsUpdateAutoTab(value))
              setAutoupdate(value)
              sendGTMEvent({
                event: "umc_directory_synchro",
                action: value ? "DS_Auto_Update_Enabled" : "DS_Auto_Update_Disabled"
              })
            }
            }
          />
          {autoUpdate ?
            <Tooltip title={getTranslated(dict, "INFO_AUTO_UPDATE")} >
              <InfoCircleFilled style={{ color: PURPLE }} />
            </Tooltip>
            :
            <Tooltip title={getTranslated(dict, "INFO_MANUAL_UPDATE")} >
              <InfoCircleFilled style={{ color: PURPLE }} />
            </Tooltip>
          }
        </div>

        <UMCButton
          label={getCreateLable()}
          type={(getSelectedRowCreateID()?.length > 0) ? "primary" : ""}
          className="cont-header-btn"
          onClick={() => {
            const selectedRowCreateID = getSelectedRowCreateID()
            if (selectedRowCreateID?.length > 0) {
              dispatch(setUserSCIMId(selectedRowCreateID))
              dispatch(setCreateUserFromDirectorySynchro(true))
              dispatch(setDirectorySynchroMode("CREATE"))
              triggerGTMActionEvents("Bulk CREATE")
            }
          }}
        />
      </div>
    )
  }

  const setListViewMode = (value) => {
    if (!value) return;
    setSelectedRows([])
    dispatch(setCreateUserFromDirectorySynchro(false))
  }

  return (
    <div id="inner-tab-content">
      {!createUserFromDirectorySynchro ?
        <>
          <div style={{ marginBottom: "14px" }}>{getTableHeader()}</div>
          {getTable()}
        </> : directorySynchroMode === "CREATE" ?
          <UserProfileSummaryView
            setListViewMode={null}
            heading_1={getTranslated(dict, "MSG_CHOOSE_PROF")}
            heading_2={getTranslated(dict, "MSG_SEL_PERSONALIZED_PROF")}
            isFromDirectorySynchro={true}
            selectedRows={setSelectedRows}
          /> : directorySynchroMode === "MODIFY" ?
            <>
              <CreateUserDetailView
                selectedUser={directorySychroUserDN}
                directrySynchroSCIMID={userSCIMId}
                directorySychroUserDN={directorySychroUserDN}
                directorySynchroMode={directorySynchroMode}
                isFromDirectorySynchro={true}
                changeCreateMode={setListViewMode}
                mode={UPDATE}
              />
            </> : (directorySynchroMode === "CHECK" || Object.keys(directorySynchroCompareTableSchema || {}).length !== 0) ?

              <>
                <CreateUserDetailView
                  selectedUser={directorySychroUserDN}
                  directrySynchroSCIMID={userSCIMId}
                  directorySychroUserDN={directorySychroUserDN}
                  directorySynchroMode={directorySynchroMode}
                  isFromDirectorySynchro={true}
                  changeCreateMode={setListViewMode}
                  mode={UPDATE}
                />
              </> :
              <></>

      }
    </div>
  )
}

export default DirectorySynchroList
